/**
 * Auxiliary variable declaration for build app in development or production modes.
 */
export const environment = {
	production: false,
	envName: 'uat',
	storeRuntimeChecksEnabled: false,
	baseApiURL: 'https://dash.auroravts.com',
	baseAuthURL: 'https://dash.auroravts.com',
};
